import currencyFormatter from "./currencyFormatter";

const formatSignedAmount = (value) => {
  const amount = Number(value) || 0;

  return amount < 0
    ? { text: `(${currencyFormatter.format(Math.abs(amount))})`, className: "amount-negative" }
    : { text: currencyFormatter.format(amount), className: "" };
};

export default formatSignedAmount;
